import { storyblokEditable } from "@storyblok/react/rsc";
import type { TableOfContentsItemStoryblok } from "@/component-types-sb";

type TableOfContentsItemProps = {
  blok: TableOfContentsItemStoryblok;
};

const TableOfContentsItem = ({ blok }: TableOfContentsItemProps) => (
  <li className="pb-3 border-b border-gray-25" {...storyblokEditable(blok)}>
    <div className="text-copy-bold text-gray-900 hover-underline-animation">
      {blok.link ? <a href={`#${blok.link.anchor}`}>{blok.name}</a> : blok.name}
    </div>
  </li>
);

export default TableOfContentsItem;
